<span [class.clickable-link]="file?.key" (click)="download.emit(file)">
	<i [class]="loading ? 'fa fa-spin fa-circle-o' : 'fa fa-file'"> </i>
	{{ name }}
</span>

@if (!loading) {
	<i class="remove-icon fa fa-trash" (click)="remove.emit()"></i>
}
